<template lang="pug">
#screen.screen
  header#header
    #status-bar.level
      .branding.title
        slot(name="branding")

      .clock: text-clock


  main#main
    section#breadcrumbs Livres numériques

    slot

    section#tabs: .tabs
      screen-tab.home(path="/", image="/tabs/En vedette.svg")
      screen-tab(path="/sujets", image="/tabs/Par Sujet.svg")

  footer#footer
    .container
      p.small Propulsé par Manivelle
</template>

<script>
import ScreenTab from "/src/components/ScreenTab.vue";
import TextClock from "/src/components/TextClock.vue";

export default {
  name: "AppScreen",

  components: {
    ScreenTab,
    TextClock,
  },

  data() {
    return {};
  },

  computed: {},
};
</script>

<style lang="scss">

@mixin backdrop-blur($size) {
  -webkit-backdrop-filter: blur($size);
  backdrop-filter: blur($size);
}


h2 {
  color: white;
  font-weight: 500;
  font-size: 2em;
  margin: 0 0 0.3em;
}

a,
a:visited {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
}

.level {
  display: flex;
  justify-content: space-between;
  align-items: center;
}



//- Full height
html { height: -webkit-fill-available; }
html, body { margin: 0; }

body, .screen {
  height: 100vh;
  min-height: 100vh;
  min-height: -webkit-fill-available;
  max-height: 100vh;
  overflow: hidden;
}


//-  Font
.screen { font-family: Work Sans, sans-serif; }

//- Font size
@media (max-height: 800px) {
  html { font-size: 12px; }
}

@media (max-width: 959px) {
  html { font-size: 12px; }
}

@media (min-height: 1920px) {
  html { font-size: 18px; }
}

@media (min-height: 2160px) {
  html { font-size: 32px; }
}

//- Screen layout
.screen {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > * { width: 100%; }
  #view { width: 100%; }

  // > header { flex-basis: 12%; }
  // > header #status-bar { width: 100%; }
}

// Needs to shrink within full-height flex container
#main { flex: 1 1 auto; min-height: 0; }


#main { display: flex; flex-direction: column; justify-content: space-between; }

#view { flex-grow: 1; }


#breadcrumbs { padding: 1em; }
#view { padding: 2em; }
#footer { padding: 0.5em 2em; }

#breadcrumbs { font-size: 1.1em }
#footer { font-size: 0.9em; }

// Screen: Base theme
.screen { color: white; }
#header { color: white; }

#status-bar { background: var(--status-bar-color); }
#footer { background: var(--footer-color, #111111); color: #ffffff66; }


#breadcrumbs { background: var(--breadcrumbs-color, #142B40); }
#tabs { background: var(--tabs-color, #222); }


// Themes

.theme-bsi {
  #main { background: rgba(0, 0, 0, 0) linear-gradient(rgb(162, 45, 73) 0%, rgb(86, 24, 20) 100%) repeat scroll 0% 0%; }
  --status-bar-color: #D82136;
  --breadcrumbs-color: #142B40;
  --tabs-color: hsl(208, 50%, 20%);

  .button,
  .primary.button {
    background: hsl(208, 60%, 35%);
    border: 1px solid hsl(208, 60%, 20%);
  }
}

.theme-2 {
  #header {
    background: rgba(255, 255, 255, 0.1);
    @include backdrop-blur(10px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  }

  #footer {
    background: #2A374Bcc;
    color: white;
    @include backdrop-blur(10px);

    border-radius: 9px 9px 0px 0px;

    a { color: #ffffff99; }
  }

  // .screen {
  //   background-size: cover;
  //   background-position: center;
  // }
}

.theme-banq {
  #main { background: hsl(16, 80%, 30%); }

  /* background: hsl(16, 82%, 20%); */
  /* background: linear-gradient(180deg, #e3e4db, #f0cea0); */

  --status-bar-color: hsl(209, 90%, 33%);
  --breadcrumbs-color: hsl(16, 82%, 45%);
  --tabs-color: hsl(16, 40%, 15%);

  #status-bar {
    border-bottom: 0.1em solid hsl(209, 20%, 25%);
  }
}

#header {
  > * { padding: 1em; }
  #status-bar { font-size: 1.4em; }

  .title {
    font-size: 0.7em;
    line-height: 1.2;
  }

  .title :is(b, strong) {
    display: block;
    font-size: 1.5em;
    font-weight: 600;
  }

  .clock {
    display: flex;
    align-items: center;
    font-size: 2em;
    font-weight: 600;
  }
}


.items.horizontal {
  display: flex;
  overflow: scroll;
  gap: 0.8em;
}

.items .item {
  border-radius: 5px;
  flex: none;
}



.section1 .card {
  width: 9em;
  height: 13em;
}


.tabs{ display: flex; justify-content: space-around; }

#tabs {
  font-size: 1.2em;
  @media (max-aspect-ratio: 1/1) { font-size: 1.4em; }

  padding: 0.6em;

  img { height: 4em; }

  .tab { padding-top: 0.4em; }

  .disabled { cursor: not-allowed; }
}



.title-card {
  .title {
    font-size: 1.2em;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 0.3em;
  }

  .authors {
    font-size: 0.85em;
    margin-top: 0.5em;
  }
}

</style>
